<template>
  <div class="min-h-screen">
    <!-- SEO Meta Tags -->
    <PageSEO
      title="Our Services - Web Development & Digital Solutions"
      description="Comprehensive web development services including frontend, backend, API and mobile app development, and DevOps. Expert solutions tailored to your business needs."
      :keywords="['web development services', 'frontend development', 'backend development', 'API development', 'mobile app development', 'React Native', 'DevOps', 'digital solutions']"
      url="https://vedware.com/services"
    />

    <!-- Hero Section -->
    <HeroSection
      :icon="PhStack"
      title="Our"
      highlighted-title="Services"
      description="Comprehensive web and mobile development solutions tailored to your business needs. From frontend to backend, we deliver exceptional digital experiences."
    />

    <!-- Services Grid -->
    <ServicesGrid
      title="What We"
      highlighted-title="Offer"
      description="Our expertise spans the entire web development lifecycle, ensuring your project is built with the latest technologies and best practices."
      :services="services"
    />

    <!-- CTA Section -->
    <ServiceCTA
      title="Ready to Start Your"
      highlighted-title="Project?"
      description="Let's discuss your requirements and create a solution that exceeds your expectations."
      primary-button-text="Get in Touch"
      secondary-button-text="View Our Work"
      secondary-button-link="/projects"
    />
  </div>
</template>

<script setup lang="ts">
import { PhStack } from '@phosphor-icons/vue'
import ServiceCTA from '~/components/Services/ServiceCTA.vue'
import ServicesGrid from '~/components/Services/ServicesGrid.vue'
import HeroSection from '~/components/Shared/HeroSection.vue'
import PageSEO from '~/components/Shared/PageSEO.vue'
import { services } from '~/data/services'
</script>
